import { Component } from "@angular/core";
import { ControlValueAccessor, FormsModule, NG_VALUE_ACCESSOR } from "@angular/forms";

@Component({
    selector: "kb-gift-card-message-input",
    standalone: true,
    imports: [
        FormsModule
    ],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: GiftCardMessageInputComponent,
            multi: true
        }
    ],
    templateUrl: "./gift-card-message-input.component.html",
    styleUrl: "./gift-card-message-input.component.css"
})
export class GiftCardMessageInputComponent implements ControlValueAccessor {
    value = "";
    private onChangeFn: (val: string) => void;
    private onTouchFn: () => void;
    private readonly maxRowLength = 28;

    get rowCount() {
        return this.value.split('\n').length
    }

    writeValue(value: string): void {
        this.value = value;
    }

    registerOnChange(fn: (value: string) => void): void {
        this.onChangeFn = fn;
    }

    registerOnTouched(fn: () => void): void {
        this.onTouchFn = fn;
    }

    onInput(val: string): void {
        const wrappedText = this.wrapText(val, this.maxRowLength);
        this.onChangeFn(wrappedText);
        this.value = wrappedText;
    }

    private wrapText(input: string, maxRowLength: number): string {
        const lines = input.split('\n');
        const result: string[] = [];

        for (const line of lines) {
            let currentLine = line.trim();

            while (currentLine.length > maxRowLength) {
                // Find the last whitespace character within the maxRowLength
                let breakPoint = currentLine.lastIndexOf(' ', maxRowLength);

                // If no whitespace is found, break at maxRowLength
                if (breakPoint === -1) breakPoint = maxRowLength;

                // Add the current line up to the breakpoint to the result
                result.push(currentLine.slice(0, breakPoint).trim());

                // Move to the remainder of the line
                currentLine = currentLine.slice(breakPoint).trim();
            }

            // Push the remaining part of the current line (if any)
            if (currentLine.length > 0) {
                result.push(currentLine);
            }
        }

        return result.join('\n');
    }
}
